export default "__VITE_ASSET__DSifGeyf__"